<template>
  <div class="answer" :style="{backgroundImage:`url(${JSON.parse(marketingActivityData.activity.templePage).drawPage.answer.background.pictureUrl})`}">

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('market', ['marketingActivityData'])
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.answer{
  height: 682px;
  background-size: 100% 100%;
}
</style>
